import React from "react";
import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";
import { partners, Partner } from "../../../assets/images/sponsors/partners";
import styles from "./SponsorsSlider.module.scss";

interface SponsorsSliderProps {
    autoPlay?: boolean;
    speed?: number;
}

const SponsorsSlider: React.FC<SponsorsSliderProps> = ({ autoPlay = true, speed = 2000 }) => {
    const [emblaRef] = useEmblaCarousel({ loop: true, align: "start" }, [
        Autoplay({ delay: speed, stopOnInteraction: false, stopOnMouseEnter: true }),
    ]);

    const getPartnerImageUrl = (imageName: string) => {
        return new URL(`../../../assets/images/sponsors/${imageName}`, import.meta.url).href;
    };

    return (
        <div className={styles.embla} ref={emblaRef}>
            <div className={styles.embla__container}>
                {partners.map((partner: Partner, index: number) => (
                    <div className={styles.embla__slide} key={index}>
                        <img
                            src={getPartnerImageUrl(partner.img)}
                            alt={partner.name}
                            className={styles.partnerLogo}
                            loading="lazy"
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SponsorsSlider;
